// extracted by mini-css-extract-plugin
export default {"targetName":"TableVods_targetName__kKpw6"};